module.exports = __webpack_public_path__ + "img/taxi.9cdadfeb.png";